export enum TransferState {
  Idle = 0,
  Ringing = 1,
  ConsultingC = 5,
  ConsultingA = 8,
  NoC_AHold = 7,
  NoA_CHold = 9,
  NoA_ConsultingC = 10,
}


/*
    Transfer states from Call Handling

    initialTransfer (0),                 // ConnectedToANoC
    callTransfer (1),                    // AOnHoldRingingTowardsC
    callTransferSuccess (2),
    callTransferBack (3),
    callTransferBackSuccess (4),
    callTransferSupervisedAnswer (5),    // AOnHoldConnectedToC
    callTransferFailed (6),
    AOnHoldNoC (7),
    AConnectedCOnHold (8),
    COnHoldNoA (9),
    CConnectedNoA (10),
    ManualDequeue (11),
    CallParked (12);
*/
